import { Dialog, DialogTitle } from '@mui/material';
import Box from '@mui/material/Box';
import { SelectAutoCompleteComponent } from '../../../../../shared/components/SelectAutoCompleteComponent';
import { Button } from '../../../../../shared/components/button/Button';
import * as Icon from '@mui/icons-material';
import { SelectAutoCompleteOptions } from '../../../../../shared/types/selectAutoComplete';
import { Input } from '../../../../../shared/components/Input';
import { InputMoney } from '../../../../../shared/components/InputMoney';
import {
  InputSelect,
  Item,
} from '../../../../../shared/components/InputSelect';

interface ModalProductSelectProps {
  handleCloseModalSearchProduct: () => void;
  modalSearchProduct: boolean;
  productIsEditing: boolean;
  modalSearchTitle: string;
  productOptions: SelectAutoCompleteOptions[];
  activeProductSelected: any;
  handleSearchProduct: (value: string, type: string) => void;
  handleAutoCompleteSelectedProduct: (value: SelectAutoCompleteOptions) => void;
  formProduct: any;
  cfopOptions: Item[];
  showCreateProduct: boolean;
  handleCreateProduct: () => void;
}

export const ModalProductSelect = ({
  handleCloseModalSearchProduct,
  modalSearchProduct,
  modalSearchTitle,
  productOptions,
  handleSearchProduct,
  handleAutoCompleteSelectedProduct,
  formProduct,
  activeProductSelected,
  productIsEditing,
  cfopOptions,
  showCreateProduct,
  handleCreateProduct,
}: ModalProductSelectProps) => {
  const { handleBlur, handleChange, touched, errors, values, handleSubmit } =
    formProduct;

  return (
    <Dialog
      onClose={() => handleCloseModalSearchProduct()}
      open={modalSearchProduct}
      fullWidth={true}
      maxWidth={'lg'}
    >
      <DialogTitle className='!font-bold !text-md'>
        {modalSearchTitle}
      </DialogTitle>
      <form className={'px-6 pb-4 pt-2 w-full'} onSubmit={handleSubmit}>
        <Box className={'grid grid-cols-12 pt-4 gap-6'}>
          <SelectAutoCompleteComponent
            disabled={productIsEditing}
            label={'Produto *'}
            value={activeProductSelected?.prod_descricao ?? ''}
            className={'col-span-6'}
            name={'search'}
            options={productOptions}
            handleSearch={(value: string) =>
              handleSearchProduct(value, 'product')
            }
            onSelectValue={handleAutoCompleteSelectedProduct}
          />
          <InputSelect
            label='Grupo Tributário'
            name='grupo_tributario'
            items={cfopOptions}
            className={'col-span-6'}
            handleChange={handleChange}
            helperText={
              errors?.grupo_tributario
                ? errors?.grupo_tributario
                : ''
            }
            error={
              !!(
                errors?.grupo_tributario
              )
            }
            value={values?.grupo_tributario ?? ''}
          />
          <Input
            label='Lote'
            name='lote'
            className={'col-span-6'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={touched?.lote && errors?.lote ? errors?.lote : ''}
            hasError={!!(touched?.lote && errors?.lote)}
            value={values?.lote ?? ''}
          />
          <Input
            label='Quantidade *'
            name='quantidade'
            className={'col-span-6'}
            type='number'
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.quantidade && errors?.quantidade
                ? errors?.quantidade
                : ''
            }
            hasError={!!(touched?.quantidade && errors?.quantidade)}
            value={values?.quantidade ?? ''}
          />
          <Input
            disabled={true}
            label='Saldo em Estoque'
            name='estoque'
            className={'col-span-6'}
            type='number'
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={touched?.estoque && errors?.estoque ? errors?.estoque : ''}
            hasError={!!(touched?.estoque && errors?.estoque)}
            value={values?.estoque ?? ''}
          />
          <InputMoney
            label={'Valor *'}
            className={'col-span-6'}
            name={'value'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={touched?.value && errors?.value ? errors?.value : ''}
            hasError={!!(touched?.value && errors?.value)}
            value={values?.value ?? ''}
          />
          <InputMoney
            label={'Desconto'}
            className={'col-span-6'}
            name={'desconto'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.desconto && errors?.desconto ? errors?.desconto : ''
            }
            hasError={!!(touched?.desconto && errors?.desconto)}
            value={values?.desconto ?? ''}
          />
          <InputMoney
            disabled={true}
            label={'Total'}
            className={'col-span-6'}
            name={'total'}
            value={values?.total ?? ''}
          />
          <Input
            label='Peso Líquido (Kg)'
            name='peso_liquido_kg'
            className={'col-span-6'}
            type='number'
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.peso_liquido_kg && errors?.peso_liquido_kg
                ? errors?.peso_liquido_kg
                : ''
            }
            hasError={!!(touched?.peso_liquido_kg && errors?.peso_liquido_kg)}
            value={values?.peso_liquido_kg ?? ''}
          />
          <Input
            label='Peso Bruto (Kg)'
            name='peso_bruto_kg'
            className={'col-span-6'}
            type='number'
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.peso_bruto_kg && errors?.peso_bruto_kg
                ? errors?.peso_bruto_kg
                : ''
            }
            hasError={!!(touched?.peso_bruto_kg && errors?.peso_bruto_kg)}
            value={values?.peso_bruto_kg ?? ''}
          />
          <Input
            disabled={true}
            label='Peso Líquido Total (Kg)'
            name='peso_liquido_total_kg'
            className={'col-span-6'}
            type='number'
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.peso_liquido_total_kg && errors?.peso_liquido_total_kg
                ? errors?.peso_liquido_total_kg
                : ''
            }
            hasError={
              !!(
                touched?.peso_liquido_total_kg && errors?.peso_liquido_total_kg
              )
            }
            value={values?.peso_liquido_total_kg ?? ''}
          />
          <Input
            disabled={true}
            label='Peso Bruto Total (Kg)'
            name='peso_bruto_total_kg'
            className={'col-span-6'}
            type='number'
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.peso_bruto_total_kg && errors?.peso_bruto_total_kg
                ? errors?.peso_bruto_total_kg
                : ''
            }
            hasError={
              !!(touched?.peso_bruto_total_kg && errors?.peso_bruto_total_kg)
            }
            value={values?.peso_bruto_total_kg ?? ''}
          />
          <InputMoney
            label={'ICMS Substituto'}
            className={'col-span-6'}
            name={'icms_substituto'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.icms_substituto && errors?.icms_substituto
                ? errors?.icms_substituto
                : ''
            }
            hasError={!!(touched?.icms_substituto && errors?.icms_substituto)}
            value={values?.icms_substituto ?? ''}
          />
          <Input
            disabled={true}
            label='Número Pedido Compra'
            name='numero_pedido_compra'
            className={'col-span-6'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.numero_pedido_compra && errors?.numero_pedido_compra
                ? errors?.numero_pedido_compra
                : ''
            }
            hasError={
              !!(touched?.numero_pedido_compra && errors?.numero_pedido_compra)
            }
            value={values?.numero_pedido_compra ?? ''}
          />
          <Input
            disabled={true}
            label='Número Item Pedido Compra'
            name='numero_item_pedido_compra'
            className={'col-span-6'}
            handleBlur={handleBlur}
            handleChange={handleChange}
            error={
              touched?.numero_item_pedido_compra &&
                errors?.numero_item_pedido_compra
                ? errors?.numero_item_pedido_compra
                : ''
            }
            hasError={
              !!(
                touched?.numero_item_pedido_compra &&
                errors?.numero_item_pedido_compra
              )
            }
            value={values?.numero_item_pedido_compra ?? ''}
          />
          <Input
            label='Percentual Redução Base de Cálculo'
            name='transporte.percentual_reducao_base_calculo'
            className={'col-span-6'}
            value={''}
          />
          <Input
            label='Percentual Redução Base de Cálculo ST'
            name='transporte.percentual_reducao_base_calculo_st'
            className={'col-span-6'}
            value={''}
          />
        </Box>

        <Box className={'px-6 pt-8 w-full flex justify-end gap-4'}>
          <Button
            variant='secondary'
            className={'!px-6'}
            onClick={() => handleCloseModalSearchProduct()}
            iconStart={<Icon.Close />}
            title={'Cancelar'}
          />
          {showCreateProduct && (
            <Button
              variant='primary'
              className={'!px-6'}
              onClick={handleCreateProduct}
              iconStart={<Icon.Create />}
              title={'Criar'}
            />
          )}
          <Button
            disabled={!activeProductSelected?.prod_id}
            variant='primary'
            className={'!px-6'}
            type={'submit'}
            iconStart={<Icon.Check />}
            title={'Confirmar'}
          />
        </Box>
      </form>
    </Dialog>
  );
};
